import apolloClient from "@/apolloClient";

import {
    OPEN_PRODUCT_TEMPLATE_IN_INDESIGN, OPEN_PAGE_TEMPLATE_IN_INDESIGN,
} from "./graphql";

const state = {};

const getters = {};

const actions = {

    async openPageTemplateInIndesign({commit}, { pageTemplateId }) {
        return apolloClient.mutate({
            mutation: OPEN_PAGE_TEMPLATE_IN_INDESIGN,
            variables: {
                pageTemplateId,
            },
        })
    },
    async openProductTemplateInIndesign({commit}, { productTemplateId }) {
        return apolloClient.mutate({
            mutation: OPEN_PRODUCT_TEMPLATE_IN_INDESIGN,
            variables: {
                productTemplateId
            },
        })
    }
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
